import { useMemo } from "react";

import type { BlOption } from "Shared/Inputs/BlOption";
import { usePriceCategoriesListQuery } from "./usePriceCategoriesListQuery";

export function usePriceCategoryOptions(): BlOption[] {
  const { data } = usePriceCategoriesListQuery({ limit: 1000 });

  return useMemo(
    () =>
      (data?.items ?? []).map((category) => ({
        value: category.priceCategoryID,
        label: category.name,
      })),
    [data],
  );
}
